export const initToc = () => {
  // all anchor tags in a .toc container are fragment links to sections on the page
  const links = Array.from(document.querySelectorAll<HTMLAnchorElement>('.toc li a'));

  // we need to store the element references as well as the visibility state, so
  // we can easily look them up later
  const targets: {
    a: HTMLAnchorElement;
    el: Element;
    visible: boolean;
  }[] = [];

  // we build up the stored references here
  links.forEach((link) => {
    // a link will have a href pointing to the target section of the page
    // targetId will look like #id
    const targetId = link.getAttribute('href');
    if (!targetId) {
      throw new Error('A toc a tag does not have an href');
    }

    // targetId looks like #id, so we use querySelector
    const target = document.querySelector(`[id="${targetId.slice(1)}"]`);
    if (!target) {
      throw new Error('A toc anchor tag target does not exist');
    }

    targets.push({ el: target, a: link, visible: false });
  });

  console.log(targets);

  const observer = new IntersectionObserver((entries) => {
    // observers simply determines visibility of every entry and stores it in
    // the local collection list
    entries.forEach((entry) => {
      const target = targets.find((t) => t.el === entry.target);
      if (!target) {
        throw new Error('Cannot find target element for observable');
      }

      target.visible = entry.intersectionRatio > 0;
    });

    // once visibility has been updated, we assign the .active class to the
    // anchor tag of the first visible element only
    const firstVisible = targets.find((t) => t.visible);

    if (firstVisible) {
      targets.forEach((t) => t.a.classList.remove('active'));
      // there are actually two anchors in the page, for different screen sizes
      // this toggles active class on both of them
      document
        .querySelectorAll(`a[href='${firstVisible.a.getAttribute('href')}']`)
        .forEach((el) => el.classList.add('active'));
      firstVisible.a.classList.add('active');
    }
  });

  targets.forEach((t) => observer.observe(t.el));
};
